module.exports = __webpack_public_path__ + "static/UNITY-TOWER-2nd-floor-modern_v2-en-dfc19f7fac49c73b09aff73588dced65.pdf";